<!-- 排出事業者 編集 -->
<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-alert
      outlined
      dense
      color="light-blue darken-4"
    >
      会社名：{{ emission.name }} 加入者番号: {{ emission.subscriber_number }}
    </v-alert>
    <Form
      v-if="emission"
      :master-emission="emission"
      @editCallback="searchEmission"
    />

    <confirm ref="confirm" />
  </v-container>
</template>

<script>
import Confirm from '../../../../components/Confirm'
import Form from './_Form'
import { mapActions } from 'vuex'

export default {
  name: 'DriverMasterEmissionEdit',
  components: {
    Confirm,
    Form,
  },
  mixins: [
  ],
  data () {
    return {
      breadcrumbs: [
        { text: '排出事業者一覧', disabled: false, to: '/driver/masters/emissions', exact: true },
        { text: '排出事業者編集', disabled: true, to: '' },
      ],
      emission: {}
    }
  },
  computed: {
  },
  created() {
    this.searchEmission()
  },
  methods: {
    ...mapActions('DriverMasterEmission', {
      showEmission: 'show'
    }),
    searchEmission () {
      this.showEmission({ id: this.$route.params.id }).then((content) => {
        this.emission = content
      })
    },
  },


}
</script>

<style lang="scss">

</style>
